export default "//static.tradera.net/touchweb/static/output/images/qr-code-google-play.f830bc2b.png";